export class DateTime {
  public static toLocaleDateTimeString(date: Date, timeZone?: string): string {
    return `${date.toLocaleDateString(navigator.language, {timeZone})}, ${date.toLocaleTimeString(navigator.language, {timeZone})}`;
  }
}

